import { memo, useCallback } from 'react';

import { DateRangeInput } from '@air/component-editable-date';

import { DateFilterTypeSelect } from '~/components/Filters/DateFilter/DateFilterTypeSelect';
import { type DateRangeType } from '~/store/filters/types';

export type DateFilterProps = {
  selectedType: DateRangeType;
  startDate?: Date;
  endDate?: Date;
  onStartDateChange: (date: Date | [Date, Date] | null) => void;
  onEndDateChange: (date: Date | [Date, Date] | null) => void;
  onTypeChange: (dateType: DateRangeType) => void;
};

export const DateFilter = memo(
  ({ startDate, endDate, selectedType, onStartDateChange, onEndDateChange, onTypeChange }: DateFilterProps) => {
    const onDateFilterTypeChange = useCallback(
      (selectedType: DateRangeType) => {
        onStartDateChange(null);
        onEndDateChange(null);
        onTypeChange(selectedType);
      },
      [onEndDateChange, onStartDateChange, onTypeChange],
    );

    return (
      <div className="flex flex-col gap-4">
        <DateFilterTypeSelect selectedType={selectedType} onTypeChange={onDateFilterTypeChange} />
        {selectedType === 'custom-range' ? (
          <DateRangeInput
            size="large"
            startDate={startDate}
            endDate={endDate}
            onStartDateChange={onStartDateChange}
            onEndDateChange={onEndDateChange}
          />
        ) : null}
      </div>
    );
  },
);

DateFilter.displayName = 'DateFilter';
